import axios from 'axios';
import { trimStringForQuery } from 'utils/utils';

const API_URL = '/api/v1/appointment/';
const SEARCH = 'search';

const getAppointmentsByPortalUser = ({ from, to, userId }) => {
	return axios.get(`${API_URL}search-by-portal-user`, {
		params: {
			from: new Date(from).toISOString(),
			to: new Date(to).toISOString(),
			userId,
		},
	});
};

const search = async ({
	filterQuery,
	pageIndex,
	pageSize,
	sortBy,
	dateRangeFilter,
}) => {
	const body = {
		page: pageIndex,
		count: pageSize,
		sortBy,
		filters: [
			{
				type: 'string',
				name: 'userName',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,
			},
			{
				type: 'string',
				name: 'callCenterName',
				value: trimStringForQuery(filterQuery),
				exactMatch: false,
			},
		],
	};

	(dateRangeFilter?.from || dateRangeFilter?.to) && body.filters.push({
		type: 'date',
		name: dateRangeFilter?.name,
		from: dateRangeFilter?.from?.toISOString(),
		to: dateRangeFilter?.to?.toISOString(),
	});
	return await axios.post(`${API_URL}${SEARCH}`, body);
};

const createAppointment = (params = {}) => axios.post(API_URL, params);

const updateAppointment = (params = {}, id) => axios.put(`${API_URL}${id}`, params);

const getAppointment = (id) => axios.get(`${API_URL}${id}`);

const deleteAppointment = (id) => axios.delete(`${API_URL}${id}`);

export {
	getAppointmentsByPortalUser,
	createAppointment,
	getAppointment,
	updateAppointment,
	deleteAppointment,
	search,
};
